<template>
    <div class="chatmsgbox">
        <div class="resultbox" v-if="!showhitory">
            <p class="total" v-if="chatresullist.records">{{chatresullist.total}}条与“{{searchValue}}”有关的聊天记录</p>

            <div class="resullist" >
                <el-scrollbar style="height: 100%;" v-loading="loading">
                    <ul>
                        <li class="clearfix" v-for="(item,index) in chatresullist.records" :key="index">
                            <el-avatar class="avatar" :size="30" :src="info.avatar"></el-avatar>
                            <div class="result_info">
                                <p>{{info.nickname}}</p>
                                <span v-html="$options.filters.contentblue(item.content,contxt)"></span>
                            </div>
                            <div class="r_tool">
                                <div class="time">{{item.createTime}}</div>
                                <a href="kavascript:;" @click="gohitory(item.id,item.wxSendTime,item.friendid,item.wechatid,item.avatar,item.nickname)">查看上下文</a>
                            </div>
                        </li>
                        <!-- <li class="clearfix">
                            <el-avatar class="avatar" :size="30" src="http://wx.qlogo.cn/mmhead/ver_1/gc7FSVBxJKX12Lbrk4LCdibV4HOqLLibr0CI4muoPDoG0M82ic4grR8G76n5wHmPibWtJvz3qwC6zibXaDJAeQZQMQD6pURZayZKz5ibbzjXqSTQI/96"></el-avatar>
                            <div class="result_info">
                                <p>名字名字名字名字名字名字</p>
                                <span>新又双叒叕进行了改动～～这次新的改动会不会比 之前的“裂变封杀”更加刺激，对于教培机构乃至企业 是好事还是坏事？</span>
                            </div>
                        </li> -->
                    </ul>
                </el-scrollbar>
            </div>
        </div>
        <div class="chathistorybox" v-if="showhitory">
            <a href="javascript:;" class="back_btn" @click="backlist"><i class="iconfont"></i>返回</a>
            <chathistorydailog :searchdata="searchdata" :rowdata="rowdata"></chathistorydailog>

        </div>
    </div>
</template>

<script>
    import {
        searchMessageContactinfo,
        searchMessage
    } from '@/utils/api-im.js'
    import chathistorydailog from '@/components/chathistorydailog.vue'
    export default{
        name:"hisresult",
        data(){
            return{
                showhitory:false,
                searchdata:{},
                rowdata:{},
                chatresullist:{},
                loading:false,
                contxt:'',
                pagesize:1
            }
        },
        components:{
            chathistorydailog
        },
        props:{
            info:{},
            searchValue:{},
            timerange:{}
        },
        filters:{
            contentblue(str,val){
                console.log(val,'this.contxt')
                let con = ''
                if(str){
                    con = str.replace(new RegExp(val,"gm"),'<b style="color: #0099FF;">'+val+'</b>')
                }
                return con
            }
        },
        watch:{
            info(){
                console.log(this.info,'info')
                this.searchchat(this.info)
            },
            searchValue(){
                console.log(this.info,'searchValue')
                this.searchchat(this.info)
            },
            timerange(){
                console.log(this.info,'timerange')
                this.searchchat(this.info)

            }
        },
        methods:{
            gohitory(id,wxSendTime,friendid,wechatid){
                this.showhitory =true
                this.searchdata ={
                    wxSendTime:wxSendTime,
                    messageId:id,
                    orderByAsc:'ASC',
                    type:1
                }
                this.rowdata={
                    friendid:friendid,
                    wechatid:wechatid,
                }
                console.log(this.searchdata,'this.searchdata')
            },
            backlist(){
                this.showhitory =false
            },
            searchchat(info,bool){
                this.loading = true
                this.showhitory =false
                this.$post(searchMessage,{
                    contactinfoId:info.sid,
                    endDate:this.timerange ? this.timerange[1] : '',
                    startDate:this.timerange ? this.timerange[0] : '',
                    content:this.searchValue,
                    pageSize:this.pagesize,
                    wechatid:info.wechatid,
                    friendid:info.friendid
                }).then(res=>{

                    if(res.data.code == 200){
                        this.pagesize = res.data.data.total
                        if(!bool){
                            this.searchchat(this.info,true)
                        }else{
                            this.loading = false
                            this.chatresullist = res.data.data
                            this.contxt = this.searchValue
                        }

                    }
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .chatmsgbox{
        height: 100%;
    }
    .chathistorybox{
        position: relative;
        padding-top: 30px;
        height: calc(100% - 30px);

        .back_btn{
            display: block;
            height: 30px;
            line-height: 30px;
            position: absolute;
            top:0;
            left: 0px;
        }

    }
    .resultbox {
        height: 100%;

        .total{
            margin-bottom: 10px;
            color: #93999F;
        }

        .resullist{
            height: calc(100% - 20px);
        }

        li {
            min-height: 40px;
            padding: 12px 0px 14px 0px;
            position: relative;

            .avatar {
                float: left;
            }

            .result_info {
                float: left;
                margin-left: 10px;
                padding-bottom: 14px;
                border-bottom: 1px solid #E7EBF3;
                width: 568px;
                position: relative;

                p {
                    font-size: 12px;
                    color: #93999F;
                    width: 326px;
                    margin: 5px 0;
                    height: 14px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                span {
                    color: #2A2A2A;
                    display: inline-block;
                    width: 326px;
                    font-size: 14px;
                    line-height: 20px;
                }
            }

            .r_tool{
                position: absolute;
                top: 22px;
                right: 30px;

                .time{
                    font-size: 12px;
                    color: #93999F;
                    margin-bottom: 5px;
                }

                a{
                    color: #0099FF;
                    font-size: 14px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/searchatresult.vue